import { api, apiRequest } from "./api";
import type {
  BillingOrderDetail,
  CapturedAfterReleaseParams,
  CapturedAfterReleaseResponse,
  TransactionDetail,
  TransactionsListParams,
  TransactionsPaginatedResponse,
} from "@/types/transactions";

export async function fetchTransactions(
  params: TransactionsListParams
): Promise<TransactionsPaginatedResponse> {
  return apiRequest(() =>
    api.get<TransactionsPaginatedResponse>("/internal/payments/logs/", {
      params,
    })
  );
}

export async function fetchBillingOrderDetail(
  orderId: string
): Promise<BillingOrderDetail> {
  return apiRequest(() =>
    api.get<BillingOrderDetail>(`/internal/billing/orders/${orderId}/`)
  );
}

export async function fetchTransactionDetail(
  transactionId: string
): Promise<TransactionDetail> {
  return apiRequest(() =>
    api.get<TransactionDetail>(`/internal/payments/logs/${transactionId}/`)
  );
}

export async function fetchBillingOrders(
  params: TransactionsListParams
): Promise<TransactionsPaginatedResponse> {
  return apiRequest(() =>
    api.get<TransactionsPaginatedResponse>("/internal/billing/orders/", {
      params,
    })
  );
}

export async function fetchCapturedAfterRelease(
  params: CapturedAfterReleaseParams
): Promise<CapturedAfterReleaseResponse> {
  return apiRequest(() =>
    api.get<CapturedAfterReleaseResponse>(
      "/internal/billing/orders/captured-after-release/",
      { params }
    )
  );
}
